import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgYoutube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Youtube",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Subtract",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.205 0.833092C14.8886 1.02067 15.4269 1.57338 15.6096 2.27526C15.9416 3.54735 15.9416 6.20156 15.9416 6.20156C15.9416 6.20156 15.9416 8.85569 15.6096 10.1279C15.4269 10.8297 14.8886 11.3825 14.205 11.5701C12.9662 11.9109 7.99817 11.9109 7.99817 11.9109C7.99817 11.9109 3.03015 11.9109 1.79124 11.5701C1.10765 11.3825 0.569299 10.8297 0.386599 10.1279C0.0546875 8.85569 0.0546875 6.20156 0.0546875 6.20156C0.0546875 6.20156 0.0546875 3.54735 0.386599 2.27526C0.569299 1.57338 1.10765 1.02067 1.79124 0.833092C3.03015 0.492188 7.99817 0.492188 7.99817 0.492188C7.99817 0.492188 12.9662 0.492188 14.205 0.833092ZM6.51172 3.96875V8.93342L10.4835 6.45118L6.51172 3.96875Z",
			fill: ""
		})
	})
});
export default SvgYoutube;
